<div class="flex sm:hidden overlay-container h-14 shadow-md">
  <div class="flex items-center justify-between w-full">
    <a [routerLink]="['/']">
      <div class="flex items-center ml-2">
        <img
          src="logo_transparent_breit_small.webp"
          alt="logo"
          class="object-cover min-w-10 h-10"
        />
      </div>
    </a>
    <div class="flex">
      <button
        (click)="toggleDrawer()"
        class="h-14 w-14 cursor-pointer hover:bg-surface-800 duration-150 transition-colors shrink-0"
      >
        <i class="fa fa-bars text-white"></i>
      </button>
    </div>
  </div>
</div>
<p-drawer
  [(visible)]="visible"
  position="right"
  [modal]="true"
  [showCloseIcon]="true"
  [style]="{
    background: 'var(--color-bg-gradient)',
    border: 'none',
  }"
>
  <ng-template #headless>
    <div class="flex flex-col h-full">
      <div class="flex items-center justify-between px-6 pt-4 shrink-0">
        <span class="inline-flex items-center gap-2 text-white">
          <a routerLink="/" class="flex items-center">
            <img
              src="logo_transparent_breit_small.webp"
              alt="logo"
              class="object-cover min-w-10 h-10"
            />
          </a>
        </span>
        <span>
          <p-button
            type="button"
            (click)="closeCallback($event)"
            icon="far fa-times"
            rounded="true"
            outlined="true"
            styleClass="h-8 w-8"
          ></p-button>
        </span>
      </div>
      <div class="overflow-y-auto">
        <div class="flex flex-col gap-2 w-full items-center mt-4 p-6">
          @for (item of navItems(); track item.routerLink) {
            @if (!item.isSpacer) {
              <a
                (click)="closeCallback($event)"
                [attr.aria-label]="item.label"
                [attr.data-tour]="item.tourKey || null"
                [routerLink]="item.disabled ? null : item.routerLink"
                routerLinkActive="text-white bg-primary"
                [routerLinkActiveOptions]="{ exact: item.exact }"
                class="px-3 py-2 rounded-lg gap-2 flex items-center transition-all duration-300 justify-start w-full"
                [ngClass]="[
                  item.disabled
                    ? 'opacity-50'
                    : 'hover:bg-primary-400 hover:text-white cursor-pointer',
                ]"
                [class.opacity-50]="item.disabled"
              >
                <i [class]="item.icon" class="text-xl text-white"></i>
                <span class="text-white">{{ item.label }}</span>
              </a>
            }
          }
        </div>
      </div>
      <div class="mt-auto">
        <div class="flex flex-col gap-2 p-2">
          <!-- User Menu -->
          <app-user-menu [collapsed]="false"></app-user-menu>
          <div
            class="flex flex-wrap gap-x-4 gap-y-1 items-center justify-center mb-1"
          >
            @for (item of navItemsRegulatory(); track item.label) {
              @if (item.action === "withdrawal") {
                <button
                  type="button"
                  [attr.aria-label]="item.label"
                  (click)="openRegulatoryItem(item, $event)"
                  class="text-xs text-white/70 transition-colors duration-200 hover:text-white hover:underline cursor-pointer hover:underline-offset-2 bg-transparent border-0 p-0"
                >
                  <span [class.hidden]="collapsed()">{{ item.label }}</span>
                </button>
              } @else if (item.url) {
                <a
                  [attr.aria-label]="item.label"
                  [href]="item.url"
                  routerLinkActive="text-white bg-white/10"
                  class="text-xs text-white/70 transition-colors duration-200 hover:text-white hover:underline cursor-pointer hover:underline-offset-2"
                >
                  <span [class.hidden]="collapsed()">{{ item.label }}</span>
                </a>
              } @else {
                <a
                  [attr.aria-label]="item.label"
                  [routerLink]="item.routerLink"
                  routerLinkActive="text-white bg-white/10"
                  class="text-xs text-white/70 transition-colors duration-200 hover:text-white hover:underline cursor-pointer hover:underline-offset-2"
                >
                  <span [class.hidden]="collapsed()">{{ item.label }}</span>
                </a>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</p-drawer>
<div
  class="hidden fixed sm:flex h-[calc(100dvh-2rem)] xl:h-[calc(100dvh-3rem)] transition-all overlay-container shadow-sm duration-300 text-white rounded-2xl z-10"
  [ngClass]="collapsed() ? 'w-(--sidebar-collapsed)' : 'w-(--sidebar-expanded)'"
  [class.pt-6]="impersonationService.isImpersonating()"
>
  <div
    class="flex flex-col justify-between h-full py-5 w-full overflow-hidden"
    [ngClass]="collapsed() ? 'px-2' : 'px-5'"
  >
    <div class="flex flex-col flex-1 gap-10 pb-10">
      <a routerLink="/" class="flex justify-center">
        @if (collapsed()) {
          <img src="standing-tiger.png" alt="logo" class="object-cover h-14" />
        } @else {
          <div class="flex items-center">
            <img
              src="logo_transparent_breit_small.webp"
              alt="logo"
              class="object-cover min-w-10 h-10"
            />
          </div>
        }
      </a>
      <div class="flex relative w-full h-full flex-col gap-2 items-center">
        @for (item of navItems(); track item.routerLink) {
          @if (item.isSpacer) {
            <div class="w-full h-auto mt-auto"></div>
          } @else {
            <a
              [attr.aria-label]="item.label"
              [attr.data-tour]="item.tourKey || null"
              [routerLink]="item.disabled ? null : item.routerLink"
              routerLinkActive="text-white bg-primary"
              [routerLinkActiveOptions]="{ exact: item.exact }"
              class="px-3 py-2 rounded-lg gap-2 flex items-center justify-starttransition-all duration-300"
              [ngClass]="[
                collapsed()
                  ? 'justify-center h-10 w-10'
                  : 'justify-start w-full',
                item.disabled
                  ? 'opacity-50'
                  : 'hover:bg-primary-400 hover:text-white  cursor-pointer',
              ]"
              [pTooltip]="collapsed() ? item.label : ''"
              [class.opacity-50]="item.disabled"
            >
              <i [class]="item.icon" class="text-xl"></i>
              <span [class.hidden]="collapsed()">{{ item.label }}</span>
            </a>
          }
        }
      </div>
    </div>
    <div
      (click)="toggleSidebar()"
      class="cursor-pointer absolute top-1/2 -translate-y-1/2 -right-4 bg-primary-500 rounded-full size-8 flex items-center justify-center shadow-sm"
    >
      @if (collapsed()) {
        <i class="far fa-arrow-right"></i>
      } @else {
        <i class="far fa-arrow-left"></i>
      }
    </div>
    <div class="flex flex-col gap-2">
      <!-- User Menu -->
      <app-user-menu [collapsed]="collapsed()"></app-user-menu>
      <div class="flex flex-col gap-0.5 items-center">
        @for (item of navItemsRegulatory(); track item.label) {
          @if (item.action === "withdrawal") {
            <button
              type="button"
              [attr.aria-label]="item.label"
              (click)="openRegulatoryItem(item, $event)"
              class="text-xs text-white/70 transition-colors duration-200 hover:text-white hover:underline cursor-pointer hover:underline-offset-2 bg-transparent border-0 p-0"
            >
              <span [class.hidden]="collapsed()">{{ item.label }}</span>
            </button>
          } @else if (item.url) {
            <a
              [attr.aria-label]="item.label"
              [href]="item.url"
              routerLinkActive="text-white bg-white/10"
              class="text-xs text-white/70 transition-colors duration-200 hover:text-white hover:underline cursor-pointer hover:underline-offset-2"
            >
              <span [class.hidden]="collapsed()">{{ item.label }}</span>
            </a>
          } @else {
            <a
              [attr.aria-label]="item.label"
              [routerLink]="item.routerLink"
              routerLinkActive="text-white bg-white/10"
              class="text-xs text-white/70 transition-colors duration-200 hover:text-white hover:underline cursor-pointer hover:underline-offset-2"
            >
              <span [class.hidden]="collapsed()">{{ item.label }}</span>
            </a>
          }
        }
      </div>
    </div>
  </div>
</div>
